// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"b86d70f0","38":"db74f0da","784":"c6f9a5c1","941":"d7413e9c"}[chunkId] + ".css";
};